module.exports = __webpack_public_path__ + "static/media/CONTRATO PROFECO Satelital 269-2020.a6eb4322.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/CONTRATO PROFECO Satelital 269-2020.pdf
// module id = 356
// module chunks = 0